import {Component, OnInit} from '@angular/core';
import {routeAnimation} from '../../route.animation';
import {Title} from '@angular/platform-browser';
import {environment} from '../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';

@Component({
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss'],
	animations: [routeAnimation]
})

export class PageNotFoundComponent implements OnInit {

	constructor(private titleService: Title,
				private translate: TranslateService) {
	}

	ngOnInit(): void {
		this.translate.get('page-titles.page-not-found').subscribe(text => this.titleService.setTitle(text));
	}
}
